var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showModal
        ? _c("app-modal-visualizar-completo", {
            attrs: {
              showModal: _vm.showModal,
              idProcesso: _vm.idProcesso,
              tipo: _vm.tipoProcesso,
              protocolo: _vm.protocolo,
              numeroProcesso: _vm.numeroProcesso
            },
            on: {
              closeModal: function($event) {
                _vm.showModal = false
              }
            }
          })
        : _vm._e(),
      _c(
        "div",
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              attrs: {
                data: _vm.processos,
                "element-loading-text": "Carregando..."
              },
              on: { "sort-change": _vm.changeOrder }
            },
            [
              _c("template", { slot: "empty" }, [_vm._v("Não há registros.")]),
              _vm.showCheckBox
                ? _c("el-table-column", {
                    attrs: { width: "40" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("el-tooltip", {
                                attrs: { placement: "right" }
                              }),
                              _c("el-checkbox", {
                                attrs: {
                                  value: _vm.vereficaSelecionado(scope.row.id)
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.selecionaItem(scope.row)
                                  }
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2291164910
                    )
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "   ", width: "30" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          [
                            _vm.getStatusAmbientalOrBloqueio(scope)
                              ? _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.getRowTooltip(scope),
                                      effect: "dark",
                                      placement: "top",
                                      "raw-content": true
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _c("i", {
                                        class:
                                          "fa fa-exclamation-triangle " +
                                          _vm.getIconStatus(scope)
                                      })
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "numeroProcesso",
                  label: "Processo",
                  width: "auto"
                }
              }),
              _vm.showSetor
                ? _c("el-table-column", {
                    attrs: {
                      prop: "setor",
                      label: "Setor",
                      formatter: _vm.formatLabelSetor,
                      width: "auto"
                    }
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  prop: "nomeRazaoSocialInteressado",
                  label: _vm.isIcmbio
                    ? "Interessado/Gleba"
                    : "Nome do interessado",
                  width: "auto"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "usuario",
                  label: "Técnico responsável",
                  width: "auto",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.isVerificaTecnico(scope.row)))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "tipo.nome",
                  label: "Tipo de processo",
                  width: "auto"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "municipioFormatado",
                  label: "Município(s)",
                  width: "auto"
                }
              }),
              _vm.showSituacaoProcesso
                ? _c("el-table-column", {
                    attrs: {
                      prop: "statusFormatado",
                      label: "Situação do processo",
                      width: "auto"
                    }
                  })
                : _vm._e(),
              _vm.showVizualizarProcesso
                ? _c("el-table-column", {
                    attrs: { label: "Ações", width: "120", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-dropdown",
                                { attrs: { trigger: "click" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "small" }
                                    },
                                    [
                                      _vm._v("Ações"),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-arrow-down el-icon--right"
                                      })
                                    ]
                                  ),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      _c("el-dropdown-item", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "flex",
                                            on: {
                                              click: function($event) {
                                                return _vm.abreModal(scope.row)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-eye"
                                            }),
                                            _vm._v("  Visualizar processo")
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3640750862
                    )
                  })
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("app-paginacao", {
            attrs: {
              total: _vm.totalItems,
              pagina: _vm.currentPage,
              tamanhoPagina: _vm.pageSize
            },
            on: { changePage: _vm.changePage }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5474d600", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5474d600","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios/components/gerais/AppListagemProcessosRelatorio.vue
// module id = null
// module chunks = 